// frontend/src/components/layout/Grid.tsx
import React, { CSSProperties, ReactNode } from 'react';

interface GridProps {
  children: ReactNode;
  custom_css?: CSSProperties;
}

const Grid: React.FC<GridProps> = ({ children, custom_css }) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gap: '1rem',
        ...custom_css,
      }}
    >
      {children}
    </div>
  );
};

export default Grid;
